module.exports = __webpack_public_path__ + "media/greninja.8298a480.wav";